import classNames from "classnames";
import React from "react";

interface IProps {
  title?: string;
  className?: string | classNames.ArgumentArray;
  children?: React.ReactNode;
  page?: string;
}

function PageTitle({ title, className, children, page }: IProps) {
  return (
    <h1
      className={classNames(
        "col-span-6 h-fit whitespace-pre-wrap font-tune text-3xl uppercase leading-tight pc:col-span-12",
        page === "collection" ? "w-3/5 text-balance text-left" : "text-center",
        className,
      )}
    >
      {title ?? children}
    </h1>
  );
}

export default PageTitle;
